<template>
  <div class="header container">
    <div class="brand tenant-logo">
      <router-link :to="Paths.HOMEPAGE">
        <img src="/logo.png" alt="tenant-logo" class="nav-logo-small doit-logo" />
      </router-link>
      <router-link v-for="logoLink in logoLinks" :key="logoLink" :to="Paths.HOMEPAGE">
        <img :src="logoLink" alt="tenant-logo" class="nav-logo-small doit-logo" />
      </router-link>
    </div>
    <el-menu class="nav" mode="horizontal" :default-active="$router.currentRoute.path" router>
      <el-menu-item v-if="!user" :index="Paths.LOGIN">Đăng nhập</el-menu-item>
      <el-menu-item v-if="user" :index="Paths.HOMEPAGE">Trang chủ</el-menu-item>
      <el-menu-item v-if="user" :index="Paths.DOCUMENT_MANAGEMENT"> Tài liệu </el-menu-item>
      <el-menu-item v-if="user && tagPermissions.includes(Permission.READ)" :index="Paths.TAG_MANAGEMENT">
        Thư mục
      </el-menu-item>
      <el-menu-item v-if="user && groupPermissions.includes(Permission.READ)" :index="Paths.GROUP_MANAGEMENT">
        Nhóm
      </el-menu-item>
      <el-menu-item index="#" @click="openGuide">
        Hướng dẫn
      </el-menu-item>
      <el-menu-item v-if="user && isAdmin" :index="Paths.ADMIN_GENERAL_STATISTIC"> Quản trị </el-menu-item>
      <el-submenu v-if="user" index="none">
        <template slot="title">
          <div class="title-container">
            <span class="email">Tài khoản</span>
          </div>
        </template>
        <el-menu-item :index="Paths.USER_PROFILE_INFORMATION">
          Tài khoản
        </el-menu-item>
        <el-menu-item :index="Paths.USER_PROFILE_SECURITY">
          Đổi mật khẩu
        </el-menu-item>
        <el-menu-item index="logout" @click="logout">
          Đăng xuất
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import EnvironmentHelper from '../helpers/EnvironmentHelper'
import { RouteNames } from '../constants/DoITConstant.js'
import { Paths } from '@/routes/paths.js'
import { EnvironmentKeys } from '@/constants/enviromentVariable.js'
import FAIcon from '@/components/common/FAIcon.vue'
import { AUTHENTICATE_STORE, AuthenticateAction, AuthenticateGetter } from '@/store/modules/AuthenticateStore.js'
import { mapGetters, mapState } from 'vuex'
import { Permission } from '@/constants/DoITConstant.js'
import { getTenantConfig } from '@/services/doit_config_service.js'

export default {
  name: 'Header',
  components: { FAIcon },
  data() {
    return {
      email: null,
      isEnable: EnvironmentHelper.isEnable,
      EnvironmentKeys,
      RouteNames,
      Paths,
      Permission,
      logoLinks: [],
    }
  },
  props: {},
  methods: {
    openGuide() {
      window.open('https://guide.doit.net.vn/', '_blank');
    },
    async logout() {
      this.$store.dispatch(AuthenticateAction.LOGOUT).then()
      this.$message.success('Đăng xuất thành công')
    },
  },
  beforeUpdate() {},
  computed: {
    ...mapState({
      user: (state) => state[AUTHENTICATE_STORE].user,
    }),
    ...mapGetters({
      isAdmin: AuthenticateGetter.IS_ADMIN,
      groupPermissions: AuthenticateGetter.GROUP_PERMISSIONS,
      tagPermissions: AuthenticateGetter.TAG_PERMISSIONS,
    }),
  },
  mounted() {
    this.$store.dispatch(AuthenticateAction.LOAD_FROM_SERVER)
    getTenantConfig().then(({ logo }) => {
      this.logoLinks = logo.split(";")
    })
  },
}
</script>

<style lang="scss" scoped>
.header {
  background-color: white;
  display: block;
  height: 86px;
  color: #fff;
  top: 0;
  left: 0;
  width: 100%;
  line-height: 86px;
  z-index: 100;
  position: relative;
  border-bottom: 1px solid whitesmoke;
}

.doit-logo {
  background-size: contain;
  display: block;
  width: auto;
  height: 56px;
  margin-right: 1rem;
}

.title-container {
  display: flex;
  flex-direction: column;

  .email {
    line-height: 2rem;
  }
}

.brand {
  margin: 0;
  float: left;
  font-size: 32px;
  display: flex;
  align-items: center;
  height: 100%;
}

.header .nav {
  float: right;
  height: 100%;
  line-height: 80px;
  background: transparent;
  padding: 0;
  margin: 0;
  border: none;
  display: flex;
  align-items: center;
}
.el-menu-item {
  height: 100% !important;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 400;
  color: #666;
  border: none !important;
}

.tenant-logo {
  margin-right: 1rem;
}
</style>

<style lang="scss">
.el-submenu__title {
  display: flex;
  flex-direction: row;
  align-items: center;

  .el-submenu__icon-arrow {
    margin-left: 10px !important;
  }
}
.el-menu-item.is-active {
  font-weight: 700;
  color: black !important;
  border-bottom: none !important;
}
.el-submenu {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
